import { OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormControl } from '@angular/forms';
import { EquipmentsApi } from '@core/api/equipments/equipments.api';
import { searchManyInputStyles } from '@core/components/fc-input/base/fc-search-many-input/fc-search-many-input.component';
import { clearEmptyProperties, endOfDay, mapCheckbox, mapIds, startOfDay } from '@core/utils/filters-utils';
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';
import { cloneDeep } from 'lodash';
import { BehaviorSubject } from 'rxjs';
import { debounceTime, tap } from 'rxjs/operators';
import { AuthenticationService } from '../../../core/authentication/authentication.service';
import { WARRANTY_STATUS } from '../../../core/consts';
import english from '../i18n/en.json';
import spanish from '../i18n/es.json';
import portuguese from '../i18n/pt.json';
var FilterEquipmentsComponent = /** @class */ (function () {
    function FilterEquipmentsComponent(fuseTranslationLoaderService, equipmentsApi, formBuilder, authenticationService) {
        this.fuseTranslationLoaderService = fuseTranslationLoaderService;
        this.equipmentsApi = equipmentsApi;
        this.formBuilder = formBuilder;
        this.authenticationService = authenticationService;
        this.types = [];
        this.locations = [];
        this.filterChanged = new BehaviorSubject({ archived: false });
        this.locationsIds = [];
        this.desiredStyle = searchManyInputStyles.Outlined;
        this.WARRANTY_STATUS = WARRANTY_STATUS;
        this.fuseTranslationLoaderService.loadJsonTranslations({ english: english, portuguese: portuguese, spanish: spanish });
    }
    FilterEquipmentsComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.equipmentsApi.getFiltersData().subscribe(function (result) {
            _this.types = cloneDeep(result['equipmentsTypes']['items']);
            _this.locations = cloneDeep(result['locations']['items']);
        });
        this.filtersForm = this.formBuilder.group({
            name: null,
            typeId: null,
            number: null,
            segmentId: null,
            locations: null,
            archived: false,
            warrantyStartDateLte: null,
            warrantyEndDateGte: null,
            warrantyStatusIn: new FormArray(WARRANTY_STATUS.map(function () { return new FormControl(false); })),
        });
        this.filtersForm.valueChanges.pipe(debounceTime(500), tap(function () {
            var filters = clearEmptyProperties({
                archived: _this.filtersForm.value.archived,
                name_contains: _this.filtersForm.value.name,
                number_contains: _this.filtersForm.value.number,
                segmentId_in: _this.filtersForm.value.segmentId,
                locationId_in: mapIds(_this.filtersForm.value.locations),
                equipmentTypeId_in: _this.filtersForm.value.typeId,
                warrantyStartDateLte: startOfDay(_this.filtersForm.value.warrantyStartDateLte),
                warrantyEndDateGte: endOfDay(_this.filtersForm.value.warrantyEndDateGte),
                warrantyStatusIn: mapCheckbox(_this.filtersForm.value.warrantyStatusIn, _this.WARRANTY_STATUS, 'name'),
            });
            _this.filterChanged.next(filters);
        })).subscribe();
    };
    FilterEquipmentsComponent.prototype.clearFilters = function () {
        this.filtersForm.patchValue({
            name: null,
            typeId: null,
            number: null,
            archived: false,
            locations: null,
            segmentId: null,
            warrantyStartDateLte: null,
            warrantyEndDateGte: null,
            warrantyStatusIn: WARRANTY_STATUS.map(function () { return false; }),
        });
    };
    return FilterEquipmentsComponent;
}());
export { FilterEquipmentsComponent };
